/** Links to Google Form used for cancelling subscription */
export enum CancelSubscriptionLinks {
  EN = 'https://docs.google.com/forms/d/e/1FAIpQLSfWv_-ubSaAbrIk9fGjZ4X5eWxhP02W5mvRCUfsZ2cbJluuvQ/viewform?usp=sf_link',
  DE = 'https://docs.google.com/forms/d/e/1FAIpQLScji8zgBOwiuyMdPC8cI2iTq0uvTEbrXhJfUjTgSooOtkYsHQ/viewform?usp=sf_link',
  FR = 'https://docs.google.com/forms/d/e/1FAIpQLSdd6P14wX1nHNEPj86bs-_MYMymoiIyjKGTG7Ut2pJn0pIBtg/viewform?usp=sf_link',
  ES = 'https://docs.google.com/forms/d/e/1FAIpQLSdKf-3QWhe2RGscVnrsHrXzUCzNvluH1eI6szqt0KVQNu0mjQ/viewform?usp=sf_link',
  NL = 'https://docs.google.com/forms/d/e/1FAIpQLSfAyjOIGvf8VUp742_Gn5j2j808nATvp2Nlv0LJURgznHoTIQ/viewform?usp=sf_link',
}

